import _styled from "@emotion/styled/base";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import { css, keyframes } from '@emotion/react';
import { getResetByTag, rem, colors } from '../../../styles';
var loaderSnake = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: ", ";\n  }\n\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: ", ";\n  }\n"])), rem(-35), rem(-125));
var loaderChange = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  100%,\n  0% {\n    stroke: ", ";\n  }\n\n  40% {\n    stroke: ", ";\n  }\n\n  65% {\n    stroke: ", ";\n  }\n\n  80%,\n  90% {\n    stroke: ", ";\n  }\n"])), colors.blue_500, colors.red_500, colors.yellow_300, colors.green_700);
var defaultStyles = function defaultStyles() {
  return /*#__PURE__*/css("animation:", loaderSnake, " 1.5s ease-in-out infinite;stroke:", colors.blue_500, ";stroke-dasharray:100,200;stroke-dashoffset:0;stroke-linecap:round;transform-origin:center center;" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var variantStyles = function variantStyles(_ref) {
  var variant = _ref.variant;
  switch (variant) {
    case 'inverse':
      return /*#__PURE__*/css("stroke:", colors.lightBlue_500, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
    case 'multi-color':
      return /*#__PURE__*/css("animation:", loaderChange, " 6s ease-in-out infinite,", loaderSnake, " 1.5s ease-in-out infinite;" + (process.env.NODE_ENV === "production" ? "" : ";label:variantStyles;"));
  }
};
var resetStyles = getResetByTag('circle');
var StyledIconPath = /*#__PURE__*/_styled('circle', process.env.NODE_ENV === "production" ? {
  target: "e1bjcefn0"
} : {
  target: "e1bjcefn0",
  label: "StyledIconPath"
})(resetStyles, defaultStyles, variantStyles);
export default StyledIconPath;